// Un reloj de refresco que se para cuando nadie esta mirando.
//
// ── EL PROBLEMA ────────────────────────────────────────────────────────────
//
// Deskte refresca varias cosas solo (la bitacora de actividad cada 30 s, las
// acciones del equipo cada 45 s, la campana de avisos). Un agente que deja la
// pestaña abierta todo el dia —que es lo normal, se deja abierta y se trabaja
// en otra cosa— sigue pidiendole al servidor cada media rueda de reloj aunque
// no haya nadie delante. Multiplicado por todas las pestañas abiertas de
// treinta agencias, es trabajo constante para el servidor que NADIE va a ver.
//
// ── LO QUE CAMBIA ──────────────────────────────────────────────────────────
//
// Mientras la pestaña esta escondida, el reloj no corre. Al volver a ella se
// refresca UNA VEZ en el acto y se reanuda.
//
// Ese refresco al volver no es un adorno: sin el, la persona veria datos
// viejos justo en el momento en que vuelve a mirar, que es exactamente cuando
// mas importa que esten frescos. Con el, vuelve y ve lo de ahora — de hecho
// mas rapido que antes, que tenia que esperar a que le tocara al reloj.
//
// NO se usa para el latido de la sesion (AuthGate) ni para la presencia de
// "quien esta viendo esta ficha": esos dos tienen que seguir latiendo con la
// pestaña escondida o el servidor concluiria que la persona se fue.

/** ¿Se esta viendo la pestaña? Fuera del navegador (pruebas), se asume que si. */
export function pestanaVisible() {
  if (typeof document === 'undefined') return true;
  return document.visibilityState !== 'hidden';
}

/**
 * Como `setInterval(fn, ms)`, pero solo mientras la pestaña se mira.
 *
 * Devuelve la funcion de limpieza: quita el reloj Y el oyente. Olvidarse del
 * oyente seria una fuga con la forma mas fea posible — cada montaje del
 * componente dejaria uno vivo, y a la decima vuelta un solo cambio de pestaña
 * dispararia diez peticiones.
 *
 * @param {() => void} fn lo que hay que hacer en cada vuelta.
 * @param {number} ms cada cuanto.
 * @param {{ alVolver?: boolean }} opciones alVolver=false si NO se quiere el
 *   refresco inmediato al regresar a la pestaña (por defecto si se quiere).
 */
export function intervaloVisible(fn, ms, opciones = {}) {
  const alVolver = opciones.alVolver !== false;
  let id = null;

  const arrancar = () => {
    if (id === null) id = setInterval(fn, ms);
  };
  const parar = () => {
    if (id !== null) { clearInterval(id); id = null; }
  };

  const alCambiarVisibilidad = () => {
    if (pestanaVisible()) {
      if (alVolver) { try { fn(); } catch (_) { /* una vuelta rota no puede matar el reloj */ } }
      arrancar();
    } else {
      parar();
    }
  };

  if (pestanaVisible()) arrancar();
  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', alCambiarVisibilidad);
  }

  return function limpiar() {
    parar();
    if (typeof document !== 'undefined') {
      document.removeEventListener('visibilitychange', alCambiarVisibilidad);
    }
  };
}
